export const en = {
  // ===== MENU =====
  menu: {
    home: "Home",
    about: "About Us",
    products: "Products - Solutions",
    investment: "Investment & Services",
    customers: "Customers - Partners",
    projects: "Typical Projects",
    contact: "Contact",
    recruitment: "Recruitment",
    news: "News",
  },

  // ===== SHAREHOLDER DOCUMENTS =====
  shareholder_documents: {
    title: "Shareholders",
    page_name: "Shareholder Documents",
    desc: "The Group's official reports and published documents are updated transparently, supporting shareholders and investors in quickly finding information.",
    search_placeholder: "Search for reports, documents...",
    clear_search: "Clear search",
    filter_by_year: "Filter by year",
    all_years: "All years",
    year: "Year",
    published_docs: "published documents",
    reset_filter: "Reset filters",
    loading: "Loading shareholder documents...",
    not_found: "No documents found",
    try_search_again:
      "Try changing keywords or the year filter to search again.",
    soon_published: "Documents for this category will be published soon.",
    view_doc: "View document",
    updating_file: "Updating file",
    hsv_corporate: "HSV CORPORATE",
    fallback_title: "Shareholder Documents",
  },

  // ===== STRATEGIC OBJECTIVES DIAGRAM =====
  strategic_objectives: {
    title: "STRATEGIC OBJECTIVES",
    left: {
      section1_title: "ECOSYSTEM DEVELOPMENT STRATEGY - ESM",
      section1_item1:
        "E-commerce Web, App, Wholesale, Retail, leading distribution in Vietnam in supplying medicines, pharmaceuticals, and medical healthcare equipment - Pharma within the Ecosystem model - ESM",
      section2_title: "DEVELOPMENT STRATEGY",
      section2_item1:
        "Sustainable development based on building a value chain, bringing the greatest utility to Enterprises, Manufacturers, Distributors, Wholesale & Retail Chain Systems, and Hospitals, Clinics. Health stations....",
      section2_item2:
        "Improve community health and physical condition of Vietnamese people.",
    },
    right: {
      section1_title: "DISTRIBUTION SYSTEM STRATEGY",
      section1_item1:
        "Integrate Distribution Management System (DMS) to increase the Connection Chain between Manufacturers, Distributors, and Sales Systems to create a tight link serving Management.",
      section1_item2: "Apply E-logistics system into the goods supply system.",
      section2_title: "SERVICE STRATEGY",
      section2_item1:
        "Integrate Call Center Solutions (3CX), Zalo, Email Hotline into a professional Customer Care Strategy.",
    },
    center: {
      top: "OBJ",
      bottom: "ECTIVES",
    },
  },

  // ===== BUSINESS MODEL DIAGRAM =====
  business_model: {
    title: "BUSINESS & MODEL",
    partners: {
      title: "Key Partners",
      items: [
        "Key partner: Main investor for the Project",
        "HSV is the Consulting partner, deploying and providing technology solutions, infrastructure",
      ],
    },
    activities: {
      title: "Key Activities",
      items: [
        "Actions",
        "Develop DMS Platform, eCommerce",
        "Build ERP System.",
        "Operate medical ecosystem, services on DMS and E-commerce Marketplace",
      ],
    },
    resources: {
      title: "Key Resources",
      items: [
        "Financial resources from investment fund partners, credit institutions + HSV to build.",
        "Technology resources to develop and operate.",
      ],
    },
    value: {
      title_top: "Products & Services (II)",
      title: "Value Proposition",
      items: [
        "Quality Value",
        "The only PaaS model in VN, allowing the convergence of Hospital Chains, Clinics, Private Practices, Health Stations, Distributors, Commercial Centers, Pharmacy Chains...",
        "DMS Systems, E-commerce Platforms, Commercial Centers and Wholesale & Retail Markets taking advantage of utilities in the System",
      ],
    },
    relationships: {
      title: "Customer Relationships",
      items: [
        "Classify customers into groups",
        "Customers via online communication channels. ( 3CX ), Zalo, Email, Hotline",
      ],
    },
    channels: {
      title: "Channels",
      items: [
        "Business of Healthcare/Pharmaceutical services via online channels with individual Customers and other Systems",
        "PaaS business via system",
      ],
    },
    segments: {
      title: "Customer Segments",
      items: [
        "Customer segments of PaaS platform are Wholesale, Retail, Hospital Chains, Clinics, Private Practices, Health Stations. Store systems, etc.",
        "State agencies managing the industry",
      ],
    },
    badges: {
      infrastructure: "Business Infrastructure (III)",
      customer: "Customers (I)",
    },
  },

  // ===== ARCHITECTURE DIAGRAM =====
  architecture_diagram: {
    sidebar_left: "EXTERNAL ORGANIZATIONS",
    sidebar_right: "SECURITY & INFO SAFETY SYSTEM\nCIRCULARS, REGULATIONS",
    external_orgs: {
      hospital: "HOSPITALS/\nCLINICS\n& AFFILIATES",
      einvoice: "E-INVOICE",
      esign: "DIGITAL\nSIGNATURE",
      payment: "PAYMENT\nGATEWAY",
      bhxh: "VIETNAM SOCIAL SECURITY",
      vnpd: "VNEID",
      boyte: "MINISTRY OF HEALTH",
    },
    top_bar: {
      doctor: "MEDICAL STAFF",
      admin: "BOARD OF DIRECTORS & OPS",
      patient: "PATIENTS",
    },
    app_layer: {
      doctor_apps: "App software for Hospital Staff\n(app, web, mobile app...)",
      patient_apps:
        "App software for Patients\n(web, mobile app, kios, hotline...)",
    },
    middle_layer: {
      exam: {
        title: "MEDICAL EXAM & TREATMENT APPS",
        items: ["EMR", "HIS", "LIS", "RIS-PACS"],
      },
      management: {
        title: "EXECUTIVE MANAGEMENT APPS",
        items: [
          "Finance & Accounting",
          "Hospital Management",
          "HR & Admin",
          "E-Documents",
          "Quality Management",
          "Analytics & Reports",
          "Equipment Management",
          "Other Applications",
        ],
      },
      patient_services: {
        title: "PATIENT APPLICATIONS",
        items: [
          "Medical Record Lookup",
          "Website, Mobile App",
          "Appointment Booking",
          "KIOS, Smart QMS",
          "Social Networks",
          "Other Systems",
        ],
      },
    },
    data_exchange: {
      boyte: {
        title: "MINISTRY OF HEALTH",
        items: [
          "Pharmacy DB",
          "Health Insurance DB",
          "Patient Info DB",
          "Other DBs",
        ],
        lgsp: "LGSP AXIS - MOH",
      },
      other_units: {
        title: "OTHER UNITS",
        items: [
          "Social Insurance DB",
          "National Population DB",
          "Digital Signature DB",
          "E-Invoice DB",
          "E-Payment DB",
          "Other DBs",
        ],
      },
      internal: {
        title: "INTERNAL HOSPITAL",
        items: [
          "AI/ML Platform",
          "BigData Platform",
          "Visualization Platform",
          "Data Exchange Standards",
          "Auth & Authorization",
          "Other Services",
        ],
      },
    },
    integration_bus: {
      title: "INTEGRATION AND DATA SHARING BUS",
      items: [
        "Shared Catalog Mgmt",
        "User Roles Mgmt",
        "Services Mgmt",
        "Patient Identification",
        "Medical Info Extract & Share",
      ],
    },
    database_layer: {
      internal_db: {
        title: "INTERNAL HOSPITAL DATABASE",
        exam: {
          title: "EXAM & TREATMENT DB",
          items: ["EMR DB", "HIS DB", "LIS DB", "RIS-PACS DB"],
        },
        management: {
          title: "EXECUTIVE MGMT DB",
          items: ["Finance DB", "Hospital Quality DB", "Research DB", "Directing DB", "Asset Mgmt DB", "E-Document DB"],
        },
      },
      data_warehouse: {
        title: "HOSPITAL DATA WAREHOUSE",
        analysis: {
          title: "ANALYTICAL DATA",
          items: [
            "Meta data management",
            "Data modeling",
            "AI/ML based Data analysis",
            "Data analysis",
          ],
        },
        storage: {
          title: "STORAGE DATA",
          items: ["Structured & Semi-structured", "Unstructured data"],
        },
      },
      external_db: {
        title: "EXTERNAL SERVICE DATABASE",
        query: {
          title: "LOOKUP DATABASE",
          items: ["Booking DB", "Result Lookup DB", "Lookup Portal DB"],
        },
      },
    },
  },

  // ===== PRODUCTS SUBMENU =====
  products_menu: {
    company_products: "Company Products",
    healthcare_solutions: "Healthcare Solutions",
    system_integration: "System Integration",
    it_services: "IT Services and Infrastructure",
    enterprise_40: "Enterprise 4.0 Solutions",
    cloud_services: "Cloud Services",
    iot_solutions: "IoT Solutions",
  },

  customers_menu: {
    typical_customers: "Typical Customers",
    strategic_partners: "Strategic Partners",
    hospital: "Hospitals & Healthcare Facilities",
    clinic: "Clinics & Dental",
    insurance: "Insurance Partners",
    service: "Service Industries",
    bank: "Banking & Finance",
    medical_supply: "Medical Supply Chain",
  },

  // ===== OTHER COMMON TEXTS =====
  common: {
    email: "Email",
    call_now: "Call Now",
    dark: "Dark",
    light: "Light",
    back_to_top: "Back to top",
    home: "Home",
    vietnamese: "Vietnamese",
    search_placeholder: "Enter search keyword...",
  },

  // ===== SEARCH =====
  search: {
    results_for: "Search results for:",
    customers: "Customers / Partners",
    projects: "Projects",
    products: "Products & Solutions",
    ecosystem: "Ecosystem",
    news: "News",
    no_results_title: "No results",
    no_results_desc1: "No content found matching the keyword",
    no_results_desc2: "Please try searching with another keyword.",
    empty_title: "Please enter a keyword",
    empty_desc: "Enter a keyword in the search box to begin.",
    searching: "Searching...",
    error: "An error occurred while searching.",
  },

  // ===== HOME =====
  home: {
    banner_subtitle: "Technology Solutions - Healthcare",
    banner_title: "Healthcare Solution VIETNAM",
    introduction_title: "About Us",
    introduction_subtitle: "HEALTHCARE SOLUTION VIETNAM",
    introduction_text:
      "Our mission is to build and develop a digital platform with advanced software tools, helping businesses elevate operational efficiency, customer experience management, care management, and customer engagement to a new level.",
    technology_title: "Advanced Platform Technology",
    technology_desc:
      "As a strategic partner of leading global IT corporations in Vietnam such as HP, Cisco, Microsoft, IBM, APC, Polycom, Oracle..., HSV delivers satisfaction through cutting-edge technology solutions and premium quality.",
    human_title: "Empowered by Human Resources",
    human_desc:
      "A team of highly experienced engineers, trained at prestigious universities and certified by globally recognized organizations such as Microsoft, Cisco, HP, DellEMC...",
    years_established: "20 Years",
    years_desc: "of formation and development.",
    revenue_target: "2,500 Billion",
    revenue_desc: "Targeted total revenue for the 2026 - 2030",
    top_12_solutions: "Top 12",
    top_12_desc:
      "Leading System Integration (SI) service providers in Vietnam.",
    awards: "3 Years",
    awards_desc:
      "Gold Cup Award from the Ho Chi Minh City Business Association.",
    products_text: "We Offer",
    products_title: "Products And Solutions",
    services_text: "Services",
    services_title: "Our Core Products",
    esm_text: "ESM",
    esm_title: "ESM ECOSYSTEM",
    esm_section_title: "ECOSYSTEM SMART MEDIC",
    esm_description:
      "ESM is a foreign-invested smart ecosystem for the healthcare industry, operating with confidence in Healthcare, Pharmaceuticals, and Technology Solutions.",
    esm_mission_title: "ESM MISSION",
    esm_mission:
      "Our mission is to enhance health and happiness by providing the best comprehensive healthcare services.",
    view_details: "View Details",
    typical_projects_text: "Featured",
    typical_projects_title: "Typical Projects",
    in_progress_text: "Projects",
    in_progress_title: "In Progress",
    section4_text: "Connection",
    section4_title: "Strategic Partners",
    news_title: "News",
    news_text: "Did you know?",
  },

  // ===== TYPICAL PROJECTS =====
  typical_projects: {
    overview: "Overview",
    hsv_role: "HSV Role",
  },

  // ===== FOOTER =====
  footer: {
    copyright: "Copyright © 2016  Healthcare Solution Viet Nam.",
    connect: "Connect",
  },

  // ===== NOT FOUND =====
  notfound: {
    title: "404",
    message: "It looks like you're lost...<br/>That's a trouble?",
    button: "Go back",
  },

  // ===== TOP BANNER - PAGES =====
  pages: {
    about: "About Us",
    products_solutions: "Products - Solutions",
    investment_services: "Investment & Services",
    customers_partners: "Customers - Partners",
    typical_projects: "Typical Projects",
    recruitment: "Recruitment",
    news: "News",
    contact: "Contact",
    leadership: "Leadership",
  },

  // ===== NEWS =====
  news: {
    news: "News",
    //   activities: "Tin Hoạt Động",
    //   events: "Tin Sự Kiện",
  },

  // ===== RECRUITMENT =====
  recruitment: {
    title: "Recruitment",
    position: "Position",
    dateup: "Posted Date",
    dateout: "Application Deadline",
    detail: "Details",
    view_detail: "View Details",
    search_placeholder: "Search open positions...",
    department_all: "All departments",
    job_type_all: "All employment types",
    clear_filter: "Clear filters",
    no_jobs: "No job openings found matching your criteria.",
    total_jobs: "open positions",

    // CV Submission Form
    badge_opportunity: "CAREER OPPORTUNITY",
    apply_now: "Apply for this position",
    apply_subtitle:
      "Send your information and CV directly to HSV Corp Recruitment Department",
    fullname_label: "Full Name",
    fullname_placeholder: "Enter your full name...",
    phone_label: "Phone Number",
    phone_placeholder: "Enter contact phone number...",
    email_label: "Email Address",
    email_placeholder: "Enter email address...",
    upload_cv_label: "Upload Resume/CV (PDF, DOC, DOCX)",
    upload_cv_button: "Click to choose CV file or attach from computer...",
    rule_hint_formats:
      "Allows doc, docx, xls, xlsx, ppt, pptx, pdf files up to 3MB",
    rule_hint_chars:
      "File name must not contain special characters such as ' /, [, *, <, >, ;",
    cover_letter_label: "Cover Letter / Note",
    tab_type_text: "✍️ Type text",
    tab_type_file: "📄 Attach file",
    cover_letter_placeholder:
      "Summarize your experience, strengths or note to the recruiter...",
    upload_cover_button: "Select Cover Letter file (PDF, DOCX)...",
    submit_btn: "Submit Application",
    submitting_btn: "Submitting application...",
    success_title: "Application submitted successfully!",
    success_message:
      "Thank you for your interest. HSV Corp HR Department will review and contact you as soon as possible.",
    err_invalid_file:
      "Invalid file! Allowed formats: doc, docx, xls, xlsx, ppt, pptx, pdf.",
    err_file_size: "File size exceeds the maximum limit of 3MB.",
    err_file_chars:
      "File name must not contain special characters such as ' /, [, *, <, >, ;",
    err_select_cv: "Please select your CV file.",
    err_submit_fail:
      "An error occurred while submitting your CV. Please try again.",
  },

  // ===== HSV CORP & HSV THƯƠNG MẠI OVERVIEW =====
  hsv_corp_overview: {
    sec1_badge: "PART 1: HSV CORP OVERVIEW",
    sec1_title:
      "HSV Corp Holdings - Healthcare Infrastructure & Corporate Governance",
    sec1_desc:
      "HSV Corp focuses on constructing, operating, and digitally transforming comprehensive healthcare networks including hospital chains, clinics, medical education, and patient care services.",
    sec2_badge: "PART 2: BUSINESS STRATEGY",
    sec2_title: "Strategic Business Directions & Growth Roadmap",
    sec2_desc:
      "Detailed business strategy integrating ecosystem expansion, digital transformation, M&A restructuring, and sustainable financial performance.",
    strat_1_title: "M&A & Expansion Strategy",
    strat_1_desc:
      "Systematically acquiring and restructuring regional clinics & hospitals to scale the healthcare ecosystem rapidly.",
    strat_2_title: "Digital Transformation & AI",
    strat_2_desc:
      "Integrating HIS, EMR, Telehealth and AI diagnostic tools into all healthcare operations.",
    strat_3_title: "Sustainable Financial Growth",
    strat_3_desc:
      "Building diversified revenue streams across medical services, pharmaceuticals, training, and corporate consulting.",
    nav_sec1: "1. HSV Corp Overview",
    nav_sec2: "2. Business Strategy",
    badge: "HSV CORP HOLDINGS",
    title:
      "Healthcare Infrastructure, Medical Training & M&A Financial Advisory",
    subtitle:
      "HSV_Corp focuses on building, operating, and digitizing comprehensive healthcare networks including hospital chains, clinics, medical training, patient care services, and M&A corporate restructuring advisory.",
    pillars_badge: "CORE PILLARS",
    pillars_title: "HSV Corp Ecosystem Pillars",
    projects_badge: "FEATURED PROJECTS",
    projects_title: "HSV Corp Healthcare & Strategy Projects",
    explore_btn: "Explore Details",
    // 1. Hospital chains
    hospital_title: "Hospital Chains",
    hospital_tag: "Core Medical Infrastructure",
    hospital_desc:
      "Investment, design, construction and operation of international-standard general and specialized hospital chains.",
    hospital_hl1: "HIS & EMR Integration",
    hospital_hl2: "Smart Operating Rooms & PACS",
    hospital_hl3: "JCI Standard Workflows",
    hospital_stat: "05+",
    hospital_stat_label: "Affiliated Hospitals",
    // 2. Clinic chains
    clinic_title: "Clinic Chains",
    clinic_tag: "Primary Care & Specialty",
    clinic_desc:
      "Modern medical and dental clinic network with integrated electronic health records and online booking.",
    clinic_hl1: "Online Appointment System",
    clinic_hl2: "Laboratory & Pharmacy Sync",
    clinic_hl3: "Personalized Health Cards",
    clinic_stat: "20+",
    clinic_stat_label: "Standardized Clinics",
    // 3. Education
    education_title: "Medical Training & Transfer",
    education_tag: "Human Capacity Building",
    education_desc:
      "Comprehensive training programs for medical staff, hospital management processes, and digital software transfer.",
    education_hl1: "Hospital Management Training",
    education_hl2: "Digital Skills Transfer",
    education_hl3: "Custom Enterprise Programs",
    education_stat: "1000+",
    education_stat_label: "Trained Personnel",
    // 4. Patient care
    care_title: "Customer Care & Operations",
    care_tag: "Omnichannel Engagement",
    care_desc:
      "Omnichannel support center, patient experience management, and on-demand home healthcare services.",
    care_hl1: "24/7 Support Hotline",
    care_hl2: "Feedback Management System",
    care_hl3: "Home Medical Connectivity",
    care_stat: "24/7",
    care_stat_label: "Continuous Support",
    // 5. M&A
    ma_title: "M&A & Corporate Financial Advisory",
    ma_tag: "Restructuring & Capital Raising",
    ma_desc:
      "Mergers & Acquisitions (M&A) advisory, strategic capital raising, debt advisory & restructuring, and corporate governance restructuring for healthcare enterprises.",
    ma_hl1: "Healthcare Mergers & Acquisitions (M&A)",
    ma_hl2: "Strategic Investment & Capital Raising",
    ma_hl3: "Debt Advisory & Debt Restructuring",
    ma_hl4: "Corporate Governance Restructuring",
    ma_stat: "M&A",
    ma_stat_label: "Strategic Advisory",

    // Dedicated M&A Section
    ma_section_badge: "M&A & CORPORATE FINANCIAL ADVISORY",
    ma_section_title:
      "Specialized M&A & Financial Restructuring Advisory Services",
    ma_section_desc:
      "HSV_Corp provides professional M&A consulting, capital raising, and financial restructuring solutions tailored for healthcare projects and enterprises.",

    ma_service_1_title: "Mergers & Acquisitions (M&A)",
    ma_service_1_desc:
      "Comprehensive M&A advisory for healthcare projects, hospitals, clinics & tech companies: valuation, due diligence & contract negotiation.",
    ma_service_1_f1: "Detailed valuation & Due Diligence",
    ma_service_1_f2: "Optimal transaction structuring",

    ma_service_2_title: "Capital Raising Advisory",
    ma_service_2_desc:
      "Developing capital raising plans and connecting with global financial investment funds and strategic investors.",
    ma_service_2_f1: "International pitch deck & financial model",
    ma_service_2_f2: "Connecting strategic investors & VC funds",

    ma_service_3_title: "Debt Advisory & Restructuring",
    ma_service_3_desc:
      "Comprehensive financial health assessment, debt restructuring, capital cost optimization & operational cash flow safety.",
    ma_service_3_f1: "Restructuring debt tenure & borrowing costs",
    ma_service_3_f2: "Cash flow & financial safety optimization",

    ma_service_4_title: "Corporate Restructuring",
    ma_service_4_desc:
      "Restructuring governance models, standardizing operating workflows & software, improving efficiency & enterprise value.",
    ma_service_4_f1: "Standardizing organizational structure & SOPs",
    ma_service_4_f2: "Digitization & governance performance boost",
  },
  hsv_commerce_overview: {
    badge: "HSV COMMERCE HOLDINGS",
    title: "Digital Software, Medical Commerce & Communications Network",
    subtitle:
      "HSV Commercial focuses on developing specialized software solutions, distributing medical equipment infrastructure, and running brand communication channels.",
    pillars_badge: "3 CORE PILLARS",
    pillars_title: "HSV Commercial Member Units",
    projects_badge: "HIGHLIGHT PROJECTS",
    projects_title: "Commercial Technology Projects",
    explore_btn: "View Details",
    // 1. Software
    software_title: "Software & Digital Transformation",
    software_tag: "MedTech & Software",
    software_desc:
      "Developing hospital management software (HIS), electronic medical records (EMR), clinic management, and MedTech digital transformation solutions.",
    // 2. Commerce
    commerce_title: "Commercial Distribution & Supply Chain",
    commerce_tag: "Medical Commerce",
    commerce_desc:
      "Distributing medical equipment, specialized supplies, IT server infrastructure, and cloud solutions for enterprises.",
    // 3. Media
    media_title: "Media & Communications",
    media_tag: "Digital Media",
    media_desc:
      "Healthcare brand communications, digital content creation, multi-channel PR campaigns, and media event organization.",
  },

  // ===== ESM FLOWCHART =====
  esm_flowchart: {
    title: "CORRELATION BETWEEN ESM - HEALTHCARE SECTOR AND FINANCE",
    khach_hang_title: "CUSTOMERS CHOOSE SERVICES ON THE ESM ECOSYSTEM",
    khoi_y_te: "MEDICAL - PHARMACEUTICAL BLOCK",
    tai_chinh: "Finance",
    cskh: "Customer Service - Service",
    nhan_su: "Human Resources",
    van_hanh: "Operations",
    bao_cao: "Reports<br/>- Statistics",
    dich_vu: "Services",
    goi_kham: "Check-up Packages",
    cham_soc: "Care",
    duoc_pham: "Pharmaceuticals",
    mua_bh: "Buy<br/>Insurance",
    tuyen_dung: "Recruit<br/>Doctors",
    thanh_toan: "ELECTRONIC<br/>PAYMENT<br/>PORTAL",
    ngan_hang: "BANK",
    the_ngan_hang: "Linked<br/>bank<br/>card",
    zalo_sms: "ZALO,<br/>SMS",
  },

  // ===== PAYMENT UTILITIES =====
  payment_utilities: {
    title: "Payment Utilities",
    one_card: "ONE CARD",
    medika_card: "Member Card",
    medika_link: "Card linked with Hospital\n– Clinic – Pharmacy",
    bank_card: "Card linked with Bank",
    user: "User",
    wallet: "E-Wallet",
    points: "Points\nAccumulation",
    balance_management: "Account balance\nmanagement",
    id_management: "Managed by 1 Customer\nID System",
    point_accumulation: "Accumulate points\nafter each\ntransaction",
  },

  // ===== SLIDE DATA =====
  slide_data: {
    marketOpportunity: {
      title: "Market Entry Opportunity & PPP Model",
      subtitle:
        "Transforming public hospital management into target-oriented PPP collaborative hospitals.",
      publicHospital: {
        title: "Public Hospital (Quantitative Management)",
        badge: "Current Challenges",
        items: [
          "Income bound by Ministry of Health salary scale",
          "Performance not adequately rewarded; lack of clear incentives/penalties",
          "Focus mainly on emergency patients, lack of patient-centric care",
          "IT infrastructure undervalued; work processed locally",
          "Rigid structure affected by healthcare policy barriers & lack of autonomy",
          "Lack of professional hospital managers & system management (Finance, IT, CRM)",
        ],
      },
      partnerHospital: {
        title: "PPP Collaborative Hospital (Target-Oriented)",
        badge: "HSV Opportunity Solution",
        items: [
          "Clear incentive mechanisms for medical staff; patient is the core focus",
          "Income based on productivity, efficiency, and clinical performance",
          "Heavy investment in smart IT infrastructure to increase operation & treatment efficiency",
          "System-wide workflow, enhanced cross-department coordination",
          "Flexible adaptation to health policies with high operational autonomy",
        ],
      },
    },
    coreBusinessStrategy: {
      title: "CORE BUSINESS STRATEGY",
      description:
        "HEALTHCARE SOLUTION VIETNAM focuses on treatment (medical) and diagnostics (non-medical), while concurrently developing a mix of supplementary business areas and establishing specialized companies in Pharmaceuticals, Medical Equipment, and other commercial services.",
      channels: {
        title: "SYNCHRONIZED CHANNELS",
        items: [
          "E-hospital / E-commerce",
          "Walk in",
          "Clinic",
          "Private Doctor Coop",
        ],
      },
      hospitalSystem: {
        title: "HOSPITAL SYSTEM",
        core: {
          title: "CORE BUSINESS",
          entrance: "Welcome",
          diagnostics: ["Consultation", "Subclinical", "Diagnosis", "Testing"],
          center: "MEDICA",
        },
        postMedical: {
          title: "Post-medical Accomodation",
          items: ["Patient", "Family"],
        },
      },
      subsidiaries: {
        items: [
          "Pharmaceutical Co.",
          "Commercial Service Co.",
          "Hi-Tech Medical Center",
          "In-hospital Clinics",
        ],
      },
      publicHospitals: {
        title: "PUBLIC GENERAL HOSPITALS",
      },
    },
    revenueOptimizationDetail: {
      title: "REVENUE MAXIMIZATION STRATEGY",
      subtitle:
        "Customer policy focuses on patients and influencers (doctors) across distribution channels with competitive, acceptable pricing. Therefore, maximizing revenue will focus on the following issues...",
      pillars: [
        {
          id: "patient-attraction",
          title: "Patient Attraction",
          items: [
            "Synchronized distribution channels.",
            "Cooperation with excellent doctors.",
            "Comprehensive healthcare cooperation with local enterprises.",
            "Professional hospital-hotel environment (Hospitality).",
            "Fast and efficient diagnostic processes.",
            "Professional reputation and good corporate citizenship.",
            "Listening to unspoken patient needs (mute-demand).",
            "Caring about personal issues & religious beliefs.",
          ],
          subTitle: "Patient-centric Approach",
          subItems: [
            "Home care customer service.",
            "Strong customer database (patients & relatives) for CRM.",
            "Linking with hospitals for support and technical transfer.",
            "Doctor clinics in the hospital following a U-shaped process (increasing services/person).",
            "Cooperating with excellent doctors to attract patients.",
            "Attractive remuneration based on capacity and contribution.",
          ],
        },
        {
          id: "product-price",
          title: "Services / Products",
          items: [
            "Rich service portfolio, many options.",
            "Fast update of medical advances.",
            "Exclusive services for special needs.",
            "Right to provide commercial services in common areas.",
          ],
          subTitle: "Pricing",
          subItems: [
            "Appropriate accommodation pricing to quickly fill bed capacity.",
            "Flexible pricing packages based on patient acceptance levels.",
          ],
        },
      ],
      diagram: {
        center: "PATIENT",
        middle: "DOCTOR",
        outer: "HOSPITAL",
        arrows: ["Acquire", "Cross-sell", "Up-sell", "Retain", "Advocacy"],
      },
    },
    marketBarriers: {
      title: "Market Barriers",
      subtitle:
        "Key challenges preventing single investors from entering the healthcare sector.",
      items: [
        {
          title: "Investment Capital",
          desc: "High capital requirements, slow payback period, difficulty in accessing commercial loans.",
        },
        {
          title: "Land & Infrastructure",
          desc: "Hard to find prime locations. High compensation & clearance costs. Complex and time-consuming procedures.",
        },
        {
          title: "Human Resources",
          desc: "Difficult to recruit highly specialized and renowned doctors. Complexities in managing medical staff.",
        },
        {
          title: "Patient Source",
          desc: "Patients tend to follow reputable public hospitals and famous doctors. Lack of an initial patient base.",
        },
        {
          title: "Medical Control",
          desc: "Hard to control medical complications. Easy to face public backlash and regulatory scrutiny.",
        },
      ],
    },
    pppStructure: {
      title: "Socialized Healthcare Partnership (PPP Model)",
      subtitle: "Shareholder Agreement to Establish Joint Stock Hospital (SPV)",
      phases: [
        {
          id: "inputs",
          title: "Resource Contribution",
          hsv: {
            name: "HSV INVESTOR",
            items: [
              { label: "Role", text: "Financial Investor" },
              { label: "Capital", text: "50-70% in Cash" },
              {
                label: "Operation Consulting",
                text: "Hire foreign companies/hospitals for operation & management consulting",
              },
              {
                label: "Main Responsibility",
                text: "Build hospital, provide finance. Corporate & System governance",
              },
            ],
          },
          public: {
            name: "PUBLIC HOSPITAL",
            items: [
              {
                label: "Role",
                text: "Advantage Contributor (Brand & Expertise)",
              },
              {
                label: "Capital",
                text: "30-40% via Land advantage & Hospital Brand",
              },
              {
                label: "Key Personnel",
                text: "Vice Chairman; GM. Head of Dept & tenured staff. Chairman of Medical Council",
              },
              {
                label: "Main Responsibility",
                text: "Clean land fund & procedures. Provide human resources. Professional management (Surgery & Treatment)",
              },
            ],
          },
          shared: {
            title: "SHARED RESOURCES & ANCILLARY SERVICES",
            items: [
              {
                label: "Shared License",
                text: "Use a shared hospital operating license for all activities",
              },
              {
                label: "Infrastructure",
                text: "Shared campus infrastructure & green spaces (cost sharing by area)",
              },
              {
                label: "Ancillary Services",
                text: "Provide commercial and ancillary services on the common campus",
              },
            ],
          },
        },
        {
          id: "core",
          title: "SOCIALIZED HOSPITAL (SPV)",
          subtitle:
            "Joint Stock Hospital Entity (Combination & Comprehensive Cooperation)",
          coreFunction:
            "HIGH-QUALITY SERVICES FOR EXAMINATION, SURGERY, INPATIENT CARE",
          features: [
            "Integrates powerful capital resources and international standard governance from HSV.",
            "Leverages professional expertise, brand reputation, and abundant patient source from Public Hospital.",
            "Uses a shared license for synchronous and highly efficient operations.",
            "SHARED CAMPUS INFRASTRUCTURE & GREEN SPACES (COST SHARING BY AREA).",
          ],
        },
      ],
    },
    holdingStructure: {
      title: "Planning Strategy & Holding Structure",
      subtitle:
        "Building a Holding model to own and manage member companies in a consolidated manner, ensuring strategic continuity and adaptability to market changes.",
      tabs: [
        "Selection Model",
        "Open Architecture",
        "Management Functions",
        "Structural Form",
        "Financial Governance",
      ],
      models: {
        title: "Holding Management Models",
        desc: "Based on strategic planning, we plan to establish a holding company to own and consolidate member companies, choosing between Strategic Architect and Strategic Control models.",
        axis: { left: "High Autonomy & Independence", right: "Strict Control" },
        items: [
          {
            type: "Active shareholder",
            enType: "Active shareholder",
            features:
              "Management based on whether subsidiaries achieve business results.",
            finance:
              "Allocates free cash flow to new units. Capital raising and allocation, but with unit separation.",
            color: "red",
          },
          {
            type: "Strategic Architect",
            enType: "Strategic Architect",
            features:
              "Horizontal and vertical management. Subsidiaries find business opportunities, Parent company appraises them.",
            finance:
              "Provides strategic guidelines. Capital raising and allocation, financial backing in certain operational cases.",
            color: "navy",
          },
          {
            type: "Strategic Control",
            enType: "Strategic Control",
            features:
              "Parent company seeks business opportunities and strictly controls subsidiaries.",
            finance:
              "Strategic management at Holding level, active strategic operations at subsidiary level. Shared balance sheet.",
            color: "yellow",
          },
          {
            type: "Operator",
            enType: "Operator",
            features:
              "Parent company directly manages all subsidiary operations.",
            finance:
              "Decides all strategic, governance, and operational issues. Consolidated balance sheet.",
            color: "blue",
          },
        ],
        proposal: {
          title: "Proposed Selection",
          points: [
            "Unified strategy at Holding level, ensuring high adjustment capacity for operations.",
            "Close linkage of Hospitals & Business Companies.",
            "Consolidated Holding balance sheet for subsidiaries.",
          ],
        },
      },
      architecture: {
        title: "Open Architecture",
        desc: "The Holding structure must evolve to meet strategic continuity. The solution is open architecture and customized modularization of functions.",
        layers: [
          { 
            name: "Board of Directors - BOD", 
            role: "Chairman", 
            color: "blue",
            descriptions: [
              "Central Function: Strategic leadership and control",
              "Practice good governance of Specialized Councils"
            ]
          },
          { 
            name: "Board of Executives - BOE", 
            role: "CEO", 
            color: "orange",
            descriptions: [
              "Day-to-day strategic management",
              "Specialized operational divisions by branch: Hospital, specialty, clinic",
              "Centralized management, supervision, support, and processing divisions/departments"
            ]
          },
          {
            name: "Functional Blocks",
            roles: ["Professional Blocks", "Support Blocks/Depts"],
            color: "gray",
          },
          {
            name: "Affiliated Companies (Hospitals & BU)",
            roles: [
              "General Hospital",
              "Specialized Hospital",
              "Clinics",
              "Pharmacies",
              "Medical School",
            ],
            color: "yellow",
            descriptions: [
              "Affiliated Hospital Companies",
              "Pharmaceutical Co. (Corporation model), 1 Commercial - Service Co. providing in-hospital services (laundry, food, supermarket, cleaning, parking,...)",
              "1 medical nursing training school (Cooperation)"
            ]
          },
        ],
      },
      orgChart: {
        title: "Functional & Professional Management Chart",
        desc: "Holding structure categorized by professional management blocks, providing standard directives and formats for hospitals and business units from establishment to operation.",
        ceo: "CEO",
        topStaff: ["Int'l Coop & Comm", "Strategic Board", "CSR Fund"],
        directors: ["Investment Dir.", "Business Dir.", "Professional Dir."],
        medicalCenter: "High-Tech Medical Center",
        departments: [
          {
            name: "Finance",
            tasks: [
              "Capital Raising",
              "Capital Allocation",
              "Performance Measurement",
              "Management Reports",
              "Tax Issues",
            ],
          },
          {
            name: "Accounting",
            tasks: ["Document Control", "Financial Reports"],
          },
          {
            name: "Legal",
            tasks: [
              "Operating Regulations",
              "Contract Drafting",
              "Compliance Review",
              "Legal Analysis",
            ],
          },
          {
            name: "Corporate Governance",
            tasks: [
              "Governance Guidelines",
              "BOD Comp & Appt",
              "Sub-company CG Review",
            ],
          },
          {
            name: "Human Resources",
            tasks: ["Recruitment", "Compensation", "Benefits"],
          },
          {
            name: "Internal Audit & Risk Mgt",
            tasks: ["Risk Audit", "Independent Review"],
          },
        ],
        units: [
          "Nursing Hospital",
          "Clinic",
          "Specialized Hospital",
          "Pharmaceutical Co",
          "Trading Service Co",
          "Training",
        ],
      },
      structuralForm: {
        title: "STRUCTURAL FORM OF HSV JOINT STOCK COMPANY",
        desc: "The structure of the Holding's functions ensures a clear connection between the parent company and its subsidiaries, from the promotion of establishment and investment to the transfer of executive power...",
        topLevel: ["Board of Directors", "CEO & President", "Strategy", "CSR"],
        departments: [
          {
            name: "Finance",
            tasks: [
              "Capital mobilization & allocation",
              "Consolidated Financial Management",
              "Performance measurement",
            ],
          },
          {
            name: "Management",
            tasks: [
              "General CG guidelines",
              "Title appointment",
              "BOD evaluation...",
            ],
          },
          {
            name: "Legal",
            tasks: ["Legal guidance", "Compliance management"],
          },
          {
            name: "Human Resources",
            tasks: ["Recruitment, HRM", "System management"],
          },
          {
            name: "Risk Management",
            tasks: ["Risk management", "Internal audit"],
          },
        ],
        leftMatrix: [
          { category: "Partners", items: ["BOD & Partner Management"] },
          {
            category: "Planning",
            items: [
              "Policy, direction",
              "Professional procedures",
              "Paraclinical, clinical",
            ],
          },
          {
            category: "Commercial",
            items: [
              "Business Policy",
              "Expert level sales",
              "Distribution channel management",
            ],
          },
          {
            category: "Investment",
            items: ["Promotion, investment, construction", "Transfer"],
          },
        ],
        hospitals: [
          { name: "Clinic", size: "small" },
          { name: "Specialized Hospital", size: "medium" },
          { name: "General Hospital", size: "large" },
        ],
      },
      finance: {
        title: "Corporate Financial Management Policy",
        desc: "Focusing on capital raising, target capital structure management, quantitative spending plans, and profit distribution to balance stakeholder interests.",
        categories: [
          {
            name: "CAPITAL RAISING",
            sub: [
              {
                type: "Charter Capital",
                target:
                  "Ensure capital participation of HSV and related companies. Private placement for investors. Plan for domestic/foreign listing at appropriate time.",
                choice:
                  "Target Investors: Share vision & execute prospects. Strong financial capacity & strategic support, HR... Long-term value investment, no intra-industry conflict.",
              },
              {
                type: "Debt Capital",
                target:
                  "Negotiate preferential loans from domestic banks. Each SPV & independent company is responsible for borrowing with holding negotiation support. Control target debt.",
                choice:
                  "Banks: Prioritize BIDV, Vietinbank, VCB. Package funding agreement. Min 10-year term, 3-year grace period, best rates. VIG Fund supports int'l negotiation.",
              },
            ],
          },
          {
            name: "CAPITAL ALLOCATION",
            sub: [
              {
                type: "Investment & Procurement",
                target:
                  "Holding approves and monitors annual budgets. Quantitative investment, procurement, and spending plans.",
                choice:
                  "Centralized cash management at lead bank. Determine investment, procurement limits at unit levels. Monitor approved limits.",
              },
            ],
          },
          {
            name: "PROFIT DISTRIBUTION",
            sub: [
              {
                type: "Profit Distribution",
                target:
                  "Harmonize stakeholder interests. Fully provision operational & capital reserves. Provision charity & responsible investment funds.",
                choice:
                  "Increase EVA for shareholder equity. Dividend reinvestment plan.",
              },
            ],
          },
        ],
      },
    },
    hospitalNetwork: [
      {
        name: "Quang Ngai General Hospital",
        beds: "500",
        location: "Quang Ngai",
        type: "General Hospital",
      },
      {
        name: "Vung Tau General Hospital",
        beds: "400",
        location: "Ba Ria - Vung Tau",
        type: "General Hospital",
      },
      {
        name: "Ben Tre General Hospital",
        beds: "450",
        location: "Ben Tre",
        type: "General Hospital",
      },
      {
        name: "DakLak Specialized Hospital",
        beds: "200",
        location: "Dak Lak",
        type: "Specialized Hospital",
      },
      {
        name: "Binh Thuan General Hospital",
        beds: "200",
        location: "Binh Thuan",
        type: "General Hospital",
      },
      {
        name: "Can Tho Orthopedic Hospital",
        beds: "200",
        location: "Can Tho",
        type: "Orthopedic Hospital",
      },
      {
        name: "HCMC General Hospital",
        beds: "150",
        location: "Ho Chi Minh City",
        type: "General Hospital",
      },
    ],

    strategicVision: {
      title: "Strategic Vision For Hospital Network",
      subtitle:
        "Sustainable development orientation, operational optimization, and competitive advantage enhancement for HSV Corp.",
      pillars: [
        {
          label: "Balance Quality & Investment Return",
          points: [
            "Apply advanced hospital operation and management processes to enhance efficiency.",
            "Establish KPIs to measure performance across hospitals, departments, and medical staff.",
          ],
        },
        {
          label: "Tactical Specialty Selection",
          points: [
            "General hospitals with multiple specialties, diversifying revenue streams, maximizing capacity, and generating stable income.",
            "Attract top talent through an excellent working environment and doctor scheduling to meet shareholder goals.",
            "Large customer base and efficient data mining to enhance customer growth potential.",
          ],
        },
        {
          label: "Capital Structure & M&A Strategy",
          points: [
            "Optimal capital structure incorporating strategic partners and long-term debt financing for key projects.",
            "Accelerated growth through strategic mergers and acquisitions (M&A).",
          ],
        },
        {
          label: "Hub-and-Spoke Chain Model",
          points: [
            "A healthcare network featuring the hub-and-spoke model (integrating hospitals and clinics) to build scale and a strong brand.",
            "Managing doctor specialties and service groups as key targets to fulfill demand and achieve high growth.",
          ],
        },
      ],
    },
    revenueOptimizationMatrix: {
      title: "Revenue Maximization Solutions",
      subtitle:
        "Comprehensive revenue growth driven by core factors and flexible strategies.",
      factors: [
        {
          id: "category",
          name: "Service Portfolio",
          shared: ["Service diversification.", "New product development."],
          medical: [
            "Detailed regulations for basic & supportive medical services.",
            "Rapid adaptation to medical advancements.",
            "Phased implementation of cash-cow service groups.",
          ],
          nonMedical: [
            "All-inclusive room packages & personalized special care.",
            "Professional hospitality services & value-added care products.",
          ],
        },
        {
          id: "pricing",
          name: "Pricing Strategy",
          shared: [
            "Flexible pricing policies & fee schedules.",
            "Comprehensive package examination programs.",
            "Unbundling single service prices.",
          ],
          medical: [],
          nonMedical: [],
          pricingEvolution: [
            { label: "Cost + Target Margin", short: "Cost" },
            { label: "Competitive Pricing", short: "Competition" },
            { label: "Customer Perception & Satisfaction", short: "Customer" },
            { label: "Target Price", short: "Target Price" },
          ],
        },
        {
          id: "customers_visits",
          name: "Customer Base & Visits",
          shared: [
            'Leveraging the "patient seeks doctor" psychology.',
            "Strengthening sales distribution channels.",
            "Shortened, highly efficient processing workflows.",
          ],
          medical: [
            "Inviting top doctors to open clinics within the hospital.",
            "Synchronized distribution channels & professional customer service.",
            "Collaborating with private doctors for patient referrals.",
            "High-level consultation and treatment expertise of doctors.",
          ],
          nonMedical: [
            "Dynamic pricing based on service usage, seasonal rates...",
            "Connecting patient sources through partnerships with pension funds, life insurance, and health insurance.",
            "Nursing care for officials (partnering with Military Hospital 175).",
          ],
        },
        {
          id: "pharmacy",
          name: "Pharmacy & Commercial",
          shared: [
            "Exclusive rights to provide services within the hospital campus.",
          ],
          medical: [],
          nonMedical: [],
        },
        {
          id: "other",
          name: "Other Income",
          shared: [
            "Increased income & interest rate negotiation power from centralized capital management at a lead bank.",
            "Income from industry-related investments.",
          ],
          medical: [],
          nonMedical: [],
        },
      ],
    },
    capitalStrategy: {
      title: "Capital Mobilization & Financial Management Strategy",
      subtitle:
        "Centralized cash management (Sweeping Account) & optimal capital structure targeting 1,500 Billion VND charter capital by 2026-2028.",
      equity: {
        title: "Charter Capital & Equity",
        desc: "Private placement to strategic investors sharing long-term vision; roadmap for domestic and international IPO.",
      },
      debt: {
        title: "Bank Loans & Institutional Capital",
        desc: "Negotiating preferential long-term credit (10-year term, 3-year grace period) with top banks (BIDV, Vietinbank, VCB) & VIG fund support.",
      },
      cashManagement: {
        title: "Centralized Cash Management",
        desc: "Holding centralized sweeping accounts at lead bank, allocating budgets with quantitative KPIs, and maximizing shareholder EVA.",
      },
      timeline: {
        title: "Capital Increase Roadmap (2026-2028)",
        desc: "Targeting 1,500 Billion VND total capital by 2028.",
        periods: [
          {
            year: "2026 Q1",
            total: "486 Bil",
            hsvRatio: "100%",
            investorRatio: "0%",
          },
          {
            year: "2026 Q4",
            total: "609 Bil",
            hsvRatio: "80%",
            investorRatio: "20%",
          },
          {
            year: "2027",
            total: "1,210 Bil",
            hsvRatio: "65%",
            investorRatio: "35%",
          },
          {
            year: "2028",
            total: "1,500 Bil",
            hsvRatio: "51%",
            investorRatio: "49%",
          },
        ],
      },
    },
  },
  orgChartThuongMai: {
    bod: "BOARD OF DIRECTORS",
    ceo: "GENERAL DIRECTOR",
    deputyCeo: "DEPUTY GENERAL DIR.",
    secretary: "SECRETARY",
    salesMarketing: "SALES & MARKETING DIV.",
    customerDev: "CUSTOMER DEVELOPMENT",
    projectBiz: "PROJECT BUSINESS",
    distribution: "DISTRIBUTION & RETAIL",
    customerService: "CUSTOMER SERVICE",
    marketingComm: "MARKETING & COMM.",
    technical: "TECHNICAL DIVISION",
    projectSupport: "PROJECT SUPPORT",
    techDeployment: "TECH. DEPLOYMENT",
    techCustomerSupport: "CUSTOMER SUPPORT",
    rnd: "R&D",
    support: "SUPPORT DIVISION",
    finance: "FINANCE - ACCOUNTING",
    adminHr: "ADMIN - HR",
    legal: "LEGAL",
    purchasing: "PURCHASING",
    labelLeft: "SUPERIORS ASSIGN WORK & SUPERVISE PROGRESS",
    labelRight: "EMPLOYEES PROPOSE & REPORT TO SUPERIORS",
    labelBottom: "DIVISIONS & DEPARTMENTS COORDINATE HORIZONTALLY",
    table: {
      businessDiv: "BUSINESS DIVISION",
      techDiv: "TECHNICAL DIVISION",
      supportDiv: "SUPPORT DIVISION",
      managementBoard: "BOARD OF MANAGEMENT",
      managementBoardDesc: "Manage, operate, and direct activities according to the company's general plan.",
      customerDev: "CUSTOMER DEVELOPMENT",
      customerDevDesc: "Telemarketing, customer development, identifying potential customers.",
      retail: "RETAIL",
      retailDesc: "Execute small orders, company-scale projects for 50 users.",
      project: "PROJECT",
      projectDesc: "Develop and expand customer relationships, understand and meet customer needs, achieve sales targets.",
      management: "MANAGEMENT",
      managementDesc: "",
      projectSupport: "PROJECT SUPPORT",
      projectSupportDesc: "Coordinate with the sales department to understand, consult, and propose solutions to support customers.",
      techSolutions: "TECHNOLOGY SOLUTIONS",
      techSolutionsDesc: "Research and apply new technologies, develop and deploy software technology, HIS, LIS, iCLINIC, ERP, AI, IOT, Industry 4.0.",
      systemSolutions: "SYSTEM SOLUTIONS",
      systemSolutionsDesc: "Build technical solutions, network administration, deploy technical solutions, deploy system security, focus deeply on system security, Pentest, Auditing, combined with iSEC.",
      services: "SERVICES",
      servicesDesc: "Support customers according to sales, maintenance, and warranty policies.",
      rndTraining: "R&D, TRAINING",
      rndTrainingDesc: "Develop technology and provide internal and customer training guidelines.",
      supervision: "SUPERVISION",
      supervisionDesc: "",
      financeHr: "FINANCE - ACCOUNTING - HR",
      financeHrDesc: "Finance - Accounting - Human Resources",
      administration: "ADMINISTRATION",
      administrationDesc: "Administration, Assistant"
    }
  },
  esm_pres: {
    page_title: "Ecosystem Smart Medic",
    breadcrumb_parent: "Ecosystem",
    breadcrumb_current: "Ecosystem Smart Medic",
    page_subtitle: "Comprehensive technology solutions for the Healthcare industry, connecting patients, hospitals, and pharmacies.",
    hero_kicker: "TECHNOLOGY SOLUTION FOR HEALTHCARE",
    hero_title: "Ecosystem Smart Medic",
    hero_desc: "Building and developing a smart healthcare application platform, traditionally connecting Patients with Hospitals – Clinics – Pharmacies through breakthrough Platform technology.",
    platform_intro: {
      title: "PLATFORM TECHNOLOGY APPLICATION",
      desc: "From initial analysis steps and applying Information Technology into Healthcare, HSV applies the smart solution model 'Ecosystem Smart Medic (ESM)' as follows:"
    },
    gears_relation: {
      title: "Corresponding Correlation between 'Patient' – 'Hospital – Clinic – Pharmacy' – 'Supplier'",
      heading: "In the Ecosystem Model, Hospitals – Clinics – Medical Offices – Pharmacies are understood as follows:",
      supplier: "Supplier",
      hospital: "Hospital / Clinic",
      patient: "Patient",
      items: [
        { label: "Hospital in the network:", value: "Medika, Pacific, Healthcare, Phuong Chau, Hoan My, Tam Tri ..." },
        { label: "Clinic in the network:", value: "Medika, Pacific, Healthcare, Phuong Chau, Hoan My, Tam Tri ...." },
        { label: "Pharmacy in the network:", value: "Within the ESM ecosystem (Pharmacity ......)" },
        { label: "Partnered Hospital:", value: "Medika, Pacific, Healthcare, Phuong Chau, Hoan My, Tam Tri ....." },
        { label: "Partnered Clinic:", value: "Medika, Pacific, Healthcare, Phuong Chau, Hoan My, Tam Tri ......" }
      ]
    },
    benefits_title: "10 BENEFITS OF JOINING THE SMART MEDICAL ECOSYSTEM ESM",
    benefits: {
      benefit1: "Access to Users and Medical/Pharmaceutical Information",
      benefit2: "Adapting to changes in healthcare methods",
      benefit3: "Multi-commerce",
      benefit4: "Management from Central Dashboard",
      benefit5: "Multi-channel Connectivity",
      benefit6: "Online Professional Healthcare",
      benefit7: "No Geographical Limits",
      benefit8: "Economic, Profitable, and Immediate",
      benefit9: "Medical & Pharmaceutical Customer Base",
      benefit10: "Experience Professional Digital Healthcare in the AI Era"
    },
    roles_and_features: {
      role_title: "Roles of Patient / Customer",
      role_patient: "As a \"Patient\" when undergoing treatment or medical examination",
      role_customer: "As a \"Customer\" when purchasing from suppliers partnered with Hospitals – Clinics – Pharmacies",
      ecosystem_corr_title: "Correlations in the Ecosystem",
      ecosystem_corr_1: "Seeking treatment at Hospitals – Clinics – Pharmacies within the Group or Partners",
      ecosystem_corr_2: "Seeking treatment at Hospitals – Clinics – Pharmacies under collaboration",
      ecosystem_corr_3: "Customers with a history of illness",
      ecosystem_corr_4: "Customers needing healthcare for themselves, family, relatives, and colleagues",
      feature_title: "Correlations between Customer – Hospital – Clinic – Doctor",
      f_hospital: {
        title: "HOSPITAL",
        items: [
          "Access patient information, screen and triage patients",
          "Expand customer base",
          "Provide examination packages, extended services, periodic check-ups",
          "Proactively schedule and coordinate personnel",
          "Manage examinations, statistical reports on the ESM Platform chart",
          "View Hospital locations within the nearest radius"
        ]
      },
      f_clinic: {
        title: "CLINIC",
        items: [
          "Access patient information, screen and triage patients",
          "Expand customer base according to clinic specialties",
          "Provide examination packages and pricing on the ESM ecosystem",
          "Schedule receptions and consult customers",
          "View Clinic locations within the nearest radius"
        ]
      },
      f_doctor: {
        title: "DOCTOR",
        items: [
          "Early access to patient information",
          "Comprehensively reference information into the system",
          "Access the smart medical examination and treatment system",
          "Consultation and disease diagnosis"
        ]
      },
      f_patient: {
        title: "PATIENT",
        items: [
          "Select Hospitals and Doctors by route, location, specialty",
          "Examination packages, appointments and reminders for medication and follow-ups",
          "Pre- and post-hospital screening consultation",
          "Door-to-door medication delivery",
          "View Pharmacy locations within the nearest radius",
          "Download medical records and test results",
          "Remote disease monitoring",
          "Electronic payment..."
        ]
      },
      tech_shift_title: "Patients - Customers approaching technology",
      badge_problem: "PROBLEM",
      badge_solution: "SOLUTION",
      role_source: "Patient",
      tech_overload: {
        title: "OVERLOAD IN MEDICAL EXAMINATION ROUTES",
        desc: "The overload in Hospitals, Clinics, Pharmacies and the increasing demand for healthcare require specialized examination appointments. Therefore, developing a Medical Technology Network is necessary."
      },
      tech_solution: {
        title: "ESM MEDICAL TECHNOLOGY SOLUTION",
        desc: "Develop a medical technology network for remote examination, diagnosis, and triage. Thanks to AI and Big Data technology, it coordinates the retrieval and monitoring of patients instantly and seamlessly, increasing accuracy and minimizing overload risks."
      }
    },
    traditional: {
      title: "Traditional Connections",
      subtitle: "Current approach between Patients and Hospitals – Clinics – Pharmacies",
      methods: {
        bhyt: "Through Health Insurance examination channels",
        insurance: "Partnering with Insurance consulting units",
        communication: "Through local communication channels",
        social: "Media, Advertising, Social Networks, Google Ads, KOLs/KOCs",
        referral: "Through referrals from Businesses, Friends, Relatives",
        radius: "Hospitals, Clinics, Pharmacies within a 5km radius",
        gprs: "Finding the nearest location via GPRS technology"
      },
      limitations_title: "Limitations of traditional connections",
      limitations: {
        l1: "Difficulty accessing healthcare services anytime, anywhere",
        l2: "Lack of consulting for Diseases, Medications, and Insurance",
        l3: "Hard to find the right specialists at Hospitals and Clinics",
        l4: "Limited technology-based card payment services (QR scan)",
        l5: "Difficulty accessing Electronic Medical Records",
        l6: "Broken connections with product and insurance suppliers"
      }
    },
    blockchain_title: "Storage Blockchain Platform",
    blockchain_desc: "Applying Blockchain technology in storing medical records, contracts, and payment management.",
    bc_security: "Maximum Security",
    bc_security_desc: "Decentralized data and smart contracts ensure absolute integrity and safety for medical records.",
    bc_data: "Medical Record Storage",
    bc_data_desc: "Medical records are kept transparently and easily retrieved for monitoring and treatment.",
    bc_smart: "Digital Payment",
    bc_smart_desc: "Medical examination and medication transactions are executed quickly through e-wallets and tokens."
  },

  // ===== PAYMENT UTILITIES =====
  payment_utilities: {
    title: "Payment Utilities",
    one_card: "ONE CARD",
    medika_card: "Membership Card",
    medika_link: "Linked with Hospitals\n- Clinics - Pharmacies",
    bank_card: "Linked with Banks",
    user: "User",
    wallet: "E-Wallet",
    points: "Accumulate\nPoints",
    balance_management: "Account balance\nmanagement",
    id_management: "Managed by 1\nCustomer ID System",
    point_accumulation: "Accumulate\npoints after\neach transaction",
  },

  // ===== ESM IMPLEMENTATION =====
  esm_implementation: {
    title: "Ecosystem Contribution",
    item_blockchain: "Develop\nBlockchain\nPlatform",
    item_creativity: "Increase\ninnovation in\nMedical products",
    item_connection: "Enhance\nsupply chain\nconnections",
    item_payment: "Payment\nutilities",
    item_expansion: "Develop and\nexpand derived\nservices",
    patient: "Patient",
    smart_ecosystem: "Smart Ecosystem",
    beneficiary: "Beneficiary",

    // Innovation diagram
    info_medical: "Medical Information",
    health_management: "Health Management",
    preventive_care: "Preventive Care",
    insurance: "Insurance Services",
    emr: "Electronic\nMedical Records",
    telehealth: "Online Consultation\n& Telehealth",
    home_doctor: "Home Doctor",
    online_booking: "Online Booking",
    info_product: "Medical Product\nInformation",

    // Connection & Expansion diagrams
    innovation_title: "Healthcare Product Innovation",
    connection_title: "Increase Supply Chain Connectivity",
    conn_hospital: "Hospital",
    conn_clinic: "Clinic",
    conn_supply_chain: "Medical Supply Chain",
    conn_bank: "Bank",
    conn_other_suppliers: "Other Suppliers",
    conn_non_medical: "Non-Medical Products & Services",
    expansion_title: "Develop & Expand Derivative Services - Smart Healthcare",
    exp_smartphone: "Smartphone Health Alerts",
    exp_bmi: "BMI & AI Management",
    exp_smartwatch: "Smartwatch & AI",
    exp_247: "24/7 Healthcare Services",
    exp_delivery: "Home Medicine Delivery",
    exp_records: "Medical Record Storage",
    exp_ambulance: "Door-to-door Medical Transport"
  },

  // ===== BLOCKCHAIN DIAGRAM =====
  esm_blockchain_diagram: {
    title: "Develop Blockchain platform for storing Medical records and contracts",
    transaction: "Transaction",
    patient: "Patient",
    exam: "Examination",
    payment_meds: "Payment\n& Medication",
    data_decentralized: "Decentralized\nData",
    smart_records: "Smart\nMedical\nRecords",
    home_token: "Home Token",
    master_node: "Master Node",
    pow_pos: "PoW / PoS",
    consensus: "Consensus"
  },
  
  // ===== ESM CORRELATION DIAGRAM =====
  esm_correlation_diagram: {
    title: "CORRELATION BETWEEN ESM - MEDICAL - PHARMA - DISTRIBUTORS",
    web_user: "Web User",
    app_user: "App User",
    master_platform: "MASTER PLATFORM",
    sub_platform_1: "Sub Platform 1",
    sub_platform_2: "Sub Platform 2",
    sub_platform_3: "Sub Platform 3",
    sub_platform_n: "Sub Platform n",
    token: "Token",
    consensus: "Consensus",
    pow_pos: "PoW / PoS",
    smart_contact: "SmartContact",
    call: "Call",
    tim_kiem: "Search",
    so_sanh: "Service Comparison",
    trai_nghiem: "Experience",
    dang_ky: "Medical Registration",
    thong_tin_yt: "Health Information",
    truy_xuat: "Traceability",
    mua_san_pham: "Buy Products",
    lua_chon_bs: "Choose Doctor",
    nganh_dv_khac: "Other Services",
    lich_su_gd: "Transaction History",
    kenh_tap_doan: "Corporate Channel",
    dv_ho_tro: "Support Services",
    giao_dich_ncc: "Supplier Transactions",
    tai_ho_so: "Download Medical Records, Test Results",
    ho_so_tt: "Medical Profile",
    infra_arch: "Ecosystem Architecture Infrastructure (DB, Schema, Multi-Tenant, Search Engine,...)",
    infra_cloud: "Cloud & CDN Infrastructure of ESM, HSV Ecosystem",
    blockchain: "Blockchain",
    tech_partner: "Technology Partner"
  },

  // ===== DATA SYSTEM MODEL DIAGRAM =====
  data_system_model: {
    title: "Data System Model: Key Partners",
    main_partner: "Key Partners",
    hospital: "Hospital",
    pharmacy: "Pharmacy",
    real_estate: "Real Estate",
    supplier: "Supplier",
    clinic: "Clinic",
    bank: "Bank",
    supermarket: "Supermarket",
    delivery: "Delivery",
    doctor: "Doctor",
    insurance: "Insurance",
    education: "Education",
    other_services: "Other Services"
  },

  // ===== BUSINESS MODEL TABS =====
  business_model_tabs: {
    title: "BUSINESS MODEL",
    tab_overview: "Overview",
    tab_canvas: "Canvas",
    tab_activities: "Activities",
    tab_resources: "Resources",
    tab_value: "Value",
    qr_scan_title: "SCAN QR CODE - PLATFORM IN <strong><span style=\"color: #16a34a\">ESM</span></strong> MEDICAL ECOSYSTEM - AT HOSPITALS, CLINICS, PHARMACIES, BUSINESSES & SHARED BY FRIENDS, RELATIVES",
    qr_banner_slogan: "Your health, our care",
    qr_banner_title: "Providing comprehensive <span class=\"text-blue\">healthcare services</span>",
    qr_banner_subtext: "ESM provides pharmaceutical products, medical services and healthcare",

    overview: {
      tech_group: "TECHNOLOGY PROVIDER GROUP",
      tech_group_desc: "Provides infrastructure, Cloud technology and solutions, Banking, Education, Hospitals, Real Estate, Agriculture, Forestry",
      hsv: "HSV",
      hsv_desc: "Provides Smart hardware and software technology and infrastructure solutions for the ESM Medical Ecosystem, Platform",
      others: "Other Members",
      others_1: "Help support the legal corridor.",
      others_2: "Organize, communicate, promote products.",
      others_3: "Provide product information.",
      others_4: "Perform other service transactions."
    },
    
    canvas: {
      partners: "Key Partners",
      activities: "Key Activities",
      resources: "Key Resources",
      value: "Value Propositions",
      relations: "Customer Relationships",
      channels: "Channels",
      segments: "Customer Segments",
      costs: "Cost Structure",
      revenue: "Revenue Streams"
    },

    activities: {
      title: "Key Activities",
      dev_platform: "Develop Platform for ESM Ecosystem",
      build_esm: "Build ESM Ecosystem including",
      build_1: "Medical Examination Registration",
      build_2: "Medical Industry Information",
      build_3: "Doctor Registration",
      build_4: "Lookup and view clinical results, EMR profiles",
      build_5: "Buy products, communication, others",
      build_6: "Product traceability",
      operate: "Operate ESM"
    },

    resources: {
      title: "Key Resources",
      finance: "Financial Resources",
      finance_1: "HSV",
      finance_2: "Group",
      finance_3: "Other Partners",
      tech: "Platform Tech Development",
      tech_1: "Group",
      tech_2: "HSV",
      tech_3: "Other Partners"
    },

    value: {
      title: "Value Proposition",
      v1: "The only PaaS model in VN",
      v2: "Allows Hospitals, Clinics, Private Practices, Pharmacies and Doctors to run businesses with a Chain link model",
      v3: "Product exchange on ESM Medical Ecosystem can display full product content of items",
      v4: "Patients / Customers can make IP calls right from Web / App with consulting team",
      v5: "ESM medical ecosystem gathers top doctors, providing the best products and services with full product traceability via NFC chip tech",
      v6: "Full features: Schedule appointments, call doctors, consult, buy products, private insurance, Recruit Doctors/Nurses, Organize medical seminars, traceability and product search",
      v7: "Blockchain Platform"
    },
    relations: {
      title: 'Customer Relationships',
      c1: '<strong><span style="color: #16a34a">HSV</span></strong> directly contacts Groups, <strong><span style="color: #16a34a">Medika, Pacific, Heathcare, Phuong Chau, Hoan My, Tam Tri Ai Nghia, 315</span></strong> ... and members of the Medical Ecosystem',
      c2: '<strong><span style="color: #16a34a">Medika, Pacific, Heathcare, Phuong Chau, Hoan My, Tam Tri, Ai Nghia, 315</span></strong> connect with Hospitals, Clinics, Private practices, Pharmacies, Leading doctors and medical-related partners.',
      c3_title: 'Groups, <strong><span style="color: #16a34a">Medika, Pacific, Heathcare, Phuong Chau, Hoan My, Tam Tri, Ai Nghia, 315</span></strong> connect with partners in other industries:',
      c3_list: [
        'Pharmaceuticals / Functional foods......',
        'Banking.',
        'Insurance.',
        'Express delivery.',
        'Real Estate, Agriculture, Forestry, Education',
        'etc.....'
      ]
    },
    channels: {
      title: 'Channels',
      c1_title: '<strong><span style="color: #16a34a">ESM</span></strong> Medical Ecosystem business via online channels:',
      c1_list: [
        'Customers are patients.',
        'Individual customers connected to the ecosystem.',
        'Customers buying private insurance.',
        'Corporate customers, Friends, Relatives, Family',
        'Customers participating in Health Insurance, Social Insurance, Public Health'
      ],
      c2_list: [
        'Direct Advertising Media.',
        'Customer care team at Hospital Chains - Clinics - Private practices - Pharmacies',
        'Television - Radio Advertising Media Channel.....',
        'Recruitment channel for Doctors, Nurses, Midwives',
        'Direct video conferencing channel for specialized medical seminars'
      ]
    },
    segments: {
      title: 'Customer Segments',
      c1: 'Customers of the Medical Ecosystem are individuals, business owners, organizations, etc. When joining the <strong><span style="color: #16a34a">ESM</span></strong> Medical Ecosystem, they are granted a Member ID.',
      c2: 'Hospital Chains, Clinic Chains, Pharmacy Chains, Doctors participating in the Medical field. Will be located in the <strong><span style="color: #16a34a">ESM</span></strong> system on Google Maps Vietnam',
      c3: 'Other units, organizations etc....'
    },
    revenue: {
      title: 'Revenue Streams',
      c1: 'Revenue from customers, patients, partners of <strong><span style="color: #16a34a">Medika, Pacific, Heathcare, Phuong Chau, Hoan My, Tam Tri, Ai Nghia Clinic, 315 Clinic</span></strong>.....',
      c2: 'Revenue from Partners using the Medical Ecosystem (trading floor, App, etc...',
      c3_title: 'Revenue from advertising:',
      c3_list: [
        'At Hospitals - Clinics - Private practices - Pharmacies, under <strong><span style="color: #16a34a">Medika, Pacific, Heathcare, Phuong Chau, Hoan My, Tam Tri, Ai Nghia Clinic, 315</span></strong>....',
        'At Hospitals - Clinics - Private practices - Pharmacies affiliated with <strong><span style="color: #16a34a">Medika, Pacific, Heathcare, Phuong Chau, Hoan My, Tam Tri, Ai Nghia Clinic, 315 Clinic</span></strong>.....',
        'On Website, Medical Ecosystem, <strong><span style="color: #16a34a">Medika, Pacific, Heathcare, Phuong Chau, Hoan My, Tam Tri, Ai Nghia Clinic, 315 Clinic</span></strong>....',
        'On Ecosystem App <strong><span style="color: #16a34a">Medika, Pacific, Heathcare</span></strong> Other revenues under Ecosystem <strong><span style="color: #16a34a">Medika, Pacific, Heathcare, Phuong Chau, Hoan My, Tam Tri, Ai Nghia Clinic, 315 Clinic</span></strong>....'
      ]
    }
  }
};
export default en;
